import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

let configString = process.env.VUE_APP_FIRESTORE_CONFIG
export const firebaseConfig = JSON.parse(configString)

// Initialize Firebase
initializeApp(firebaseConfig);
export const db = getFirestore();
